import { ActionIcon, Button } from '@mantine/core'
import { IconBellRinging } from '@tabler/icons'
import { useRouter } from 'next/router'

import { api, notificationHandler } from '@/lib/utils'
import { useAuth } from '@/providers/AuthProvider'

interface Props {
  productSlug: string
  variant?: 'button' | 'icon'
  [key: string]: any
}

export default function ProductAlert({ productSlug, variant = 'button', ...restProps }: Props) {
  // Hooks
  const { isAuthenticated } = useAuth() || {}
  const router = useRouter()

  // Constants
  const {
    site: siteSlug,
    channel: channelSlug,
    store: storeSlug,
    showcase: showcaseSlug
  } = router.query || {}

  // Actions
  const handleAlert = async (productSlug: string) => {
    if (!isAuthenticated) {
      router.push(`/accounts/login?callbackUrl=${router.asPath}`)
    } else {
      try {
        const response = await api.post(
          `/${siteSlug}/channels/${channelSlug}/stores/${storeSlug}/showcases/${showcaseSlug}/products/${productSlug}/alert/`
        )
        const { data, status } = response || {}
        if (status === 201 && data?.detail) {
          notificationHandler({ variant: 'success', message: response.data.detail })
        }
      } catch (error: any) {
        notificationHandler({
          variant: 'error',
          message: error?.response?.data?.detail || 'Erro ao criar alerta'
        })
      }
    }
  }

  // Render
  if (variant === 'icon') {
    return (
      <ActionIcon
        variant="subtle"
        size="lg"
        color="orange"
        onClick={() => handleAlert(productSlug)}>
        <IconBellRinging size={18} />
      </ActionIcon>
    )
  }

  return (
    <Button fullWidth color="gray.5" onClick={() => handleAlert(productSlug)} {...restProps}>
      Avise-me
    </Button>
  )
}
